import React, { Component } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import { get } from "lodash";
import { startOfToday } from "date-fns";

import TripList from "../../trip/components/TripList";
import Urls from "../../UrlConfig";
import useListWithPaginationSearch from "../../others/data/search.hook";
import { GET_TRIP_LIST } from "../../trip/data/trip.graphql";
import { TimeSelector } from "../../others/components/TimeSelector";
import Pagination from "../../others/components/Pagination";
import { GET_EXPENSE_LIST } from "../data/expense.graphql";
import ExpenseList from "../components/ExpenseList";

export default () => {
  /**
   *
   * data component - list fetch
   *
   * Parent:
   * 		App
   *
   */

  const {
    loading,
    data,
    error,
    hasNextPage,
    hasPrevPage,
    fetchNextData,
    fetchPrevData,
    pageNo,
    rowCount,
    changeRowCount,
    handleSearch,
  } = useListWithPaginationSearch(GET_EXPENSE_LIST, "expenses");

  const edges = get(data, "expenses.edges", []);

  const paginationProps = {
    pageNo,
    hasPrevPage,
    hasNextPage,
    fetchNextData,
    fetchPrevData,
    currentCount: rowCount,
    changeCount: changeRowCount,
  };

  return (
    <div id="trip-list" className="page-container">
      <div className="page-title-wrapper">
        <div className="page-title">Expenses</div>

        {/* <div className="search-wrapper">
          <ExpenseListTimeSelector handleSearch={handleSearch} />
          <div className="trip-search-container"></div>
        </div> */}
      </div>

      <div className="page-content flex-wrapper">
        <div className="flex-md secondary-bg scrollable relative">
          <div className="data-sections">
            <div className="search-result-section">
              Showing {edges.length} results
            </div>
            <div className="list-section">
              <ExpenseList
                data={edges}
                count={rowCount}
                loading={loading}
                error={error}
              />

              <Pagination {...paginationProps} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export class ExpenseListTimeSelector extends Component {
  /**
   * render time selector
   * refetch graphql trip data using selected date
   */

  state = {
    currentTimeRange: 1,
    startTime: startOfToday(),
  };

  handleChangeTime = (props) => {
    let newState = {
      currentTimeRange: props.currentTimeRange,
    };
    // in case of custom also set date
    if (props.currentTimeRange === 3) {
      newState.startTime = props.startTime;
    }
    this.setState(newState);
    // refetch gql query with updated dates
    this.props.handleSearch({
      before: undefined,
      after: undefined,
      last: undefined,
      startTime: props.startTime.toISOString(),
      endTime: props.endTime.toISOString(),
    });
  };

  render = () => {
    const { currentTimeRange, startTime } = this.state;

    return (
      <TimeSelector
        currentTimeRange={currentTimeRange}
        startTime={startTime}
        changeTimeSelection={this.handleChangeTime}
      />
    );
  };
}
